import Version from "../Version";

interface FooterProps {
  displayVersion?: boolean;
}

const Footer = (props: FooterProps) => {
  const links = [
    {
      name: "Patch Notes",
      link: "/patch-notes",
    },
    {
      name: "Terms of Service",
      link: "/terms-of-service",
    },
    {
      name: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      name: "System Status",
      link: "/status",
    },
  ];

  return (
    <div className="footer d-flex justify-content-center align-items-center">
      <span>
        ©{new Date().getFullYear().toString()} by Gallus Insights.
        {links.map((value) => {
          return (
            <>
              {" | "}
              <a
                style={{ textDecoration: "none", color: "white" }}
                href={value.link}
              >
                {value.name}
              </a>
            </>
          );
        })}
        {props.displayVersion && " | v" + Version.FullVersion}
      </span>
    </div>
  );
};

export default Footer;
